// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__dhsf6","text":"SelectPayment_text__hllVw","title":"SelectPayment_title__3zkTx","btn":"SelectPayment_btn__xUzSU"};